const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");

const AT = require("../core/vault/ActionTypes");
const CheckoutSteps = require("../office/CheckoutSteps");
const RosteringCSVSelect = require("./RosteringCSVSelect");
const RosteringReview = require("./RosteringReview");
const GenerateRoster = require("./GenerateRoster");
const {atPage, atSchoolRosters} = require("../core/vault/StateCursors");
const CopyTable = require("./data/CopyTable");

const styles = require("./styles/RosteringBody.css");

const getPropsFromVault = function(props, vaultState) {
	const roster = atSchoolRosters(vaultState).get();
	const selectedYear = atSchoolRosters(vaultState).getIn("year", "currentYear");
	const pageData = atPage(vaultState).getIn("pageData");

	const rostersValid = _.get(roster, ["validation", "valid"], false);
	const validationDone =
		_.get(roster, ["validation", "load"], "none") === "done";

	let rStep = pageData.rosteringStep;
	if (rStep && (!rostersValid || !validationDone) && rStep === "review") {
		rStep = "validate";
	}

	return {
		roster,
		selectedYear,
		rosteringStep: (rStep && rStep.replace("-", " ")) || "staff csv",
	};
};

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "RosteringBody",

		propTypes: {
			user: PT.object.isRequired,
			roster: PT.object.isRequired,
			schoolState: PT.object.isRequired,
			selectedYear: PT.string.isRequired,
			rosteringStep: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		vaultEvents: {
			processRostersSuccess: function() {
				this.props.dispatch({
					type: AT.POST_ROSTER_PROCESSING_ACCOUNT_RELOAD_REQUEST,
				});
			},
			processRostersAccountReloadSuccess: function() {
				this.props.dispatch({
					type: AT.POST_ROSTER_PROCESSING_ACCOUNT_STUDENTS_RELOAD_REQUEST,
				});
			},
		},

		getInitialState: function() {
			return {
				yearFilter: "currentYear",
			};
		},

		componentWillUnmount: function() {
			this.props.dispatch({
				type: AT.ROSTERING_RESET,
			});
		},

		onChangeStep: function(newStep) {
			this.props.dispatch({
				type: AT.ROSTERING_GO_TO_STEP,
				step: newStep,
			});
		},

		getSteps: function() {
			return ["staff csv", "student csv", "validate", "review"];
		},

		areRostersValid: function() {
			return _.get(this.props.roster, ["validation", "valid"], true);
		},

		getAvailableSteps: function() {
			const steps = ["staff csv", "student csv", "validate"];

			const {roster} = this.props;
			if (roster.validation.load === "done" && this.areRostersValid()) {
				steps.push("review");
			}
			return steps;
		},

		goToNextStep: function() {
			const steps = this.getSteps();
			const idx = _.indexOf(steps, this.getCurrentStep());
			this.props.dispatch({
				type: AT.ROSTERING_GO_TO_STEP,
				step: steps[idx + 1],
			});
		},

		goToValidate: function() {
			this.onChangeStep("validate");
		},

		getCurrentStep: function() {
			return this.props.rosteringStep;
		},

		downloadCsv: function() {
			const step = this.getCurrentStep();
			if (step === "staff csv") {
				this.downloadStaffCsv();
			} else if (step === "student csv") {
				this.downloadStudentCsv();
			}
		},

		downloadStaffCsv: function() {},

		downloadStudentCsv: function() {},

		filesValidated: function() {},

		getCurrentYear: function() {
			const {schoolState} = this.props;
			return _.get(schoolState, ["accounts", "purchase", "currentYear"]);
		},

		makeDownloadStep: function(which) {
			return (
				<GenerateRoster
					for={which}
					name={`${which}Roster`}
					continue={this.goToNextStep}
					roster={this.props.roster}
					currentYear={this.getCurrentYear()}
					schoolState={this.props.schoolState}
				/>
			);
		},

		makeValidateStep: function() {
			return (
				<RosteringCSVSelect
					currentYear={this.getCurrentYear()}
					selectedYear={this.props.selectedYear}
					roster={this.props.roster}
					onContinue={
						this.props.roster.validation.load === "done"
							? this.goToNextStep
							: _.noop
					}
					onFilesValidated={this.filesValidated}
					loadStateToStatus={{
						none: "none",
						pending: "loading",
						error: "failed",
						completed: "done",
					}}
					schoolState={this.props.schoolState}
				/>
			);
		},

		makeReviewStep: function() {
			return (
				<RosteringReview
					roster={this.props.roster}
					loadStateToStatus={{
						none: "none",
						pending: "loading",
						error: "failed",
						completed: "done",
					}}
					selectedYear={this.props.selectedYear}
					currentYear={this.getCurrentYear()}
					schoolState={this.props.schoolState}
					changeStep={this.onChangeStep}
				/>
			);
		},

		makeRosteringStep: function(stepName) {
			let step = null;

			if (stepName === "staff csv") {
				step = this.makeDownloadStep("staff");
			} else if (stepName === "student csv") {
				step = this.makeDownloadStep("student");
			} else if (stepName === "validate") {
				step = this.makeValidateStep();
			} else if (stepName === "review") {
				step = this.makeReviewStep();
			}

			return step;
		},

		renderStep: function() {
			const rosteringStep = this.getCurrentStep();
			const stepCopy = CopyTable.getRosteringStepCopy(
				rosteringStep,
				this.props.roster,
				styles,
				() => this.goToValidate()
			);
			const stepInner = this.makeRosteringStep(rosteringStep);
			const step = (
				<div className={styles.step}>
					<div className={styles.stepHeader}>{stepCopy.header}</div>
					{stepCopy.description ? (
						<div className={styles.stepDescription}>{stepCopy.description}</div>
					) : null}
					{stepInner}
				</div>
			);
			return step;
		},

		renderSteps: function() {
			const steps = this.getSteps();
			const availableSteps = this.getAvailableSteps();

			return (
				<div className={styles.main}>
					<div className={styles.steps}>
						<CheckoutSteps
							steps={steps}
							stepLabels={steps}
							availableSteps={availableSteps}
							currentStep={this.getCurrentStep()}
							onChangeStep={this.onChangeStep}
							tinyMargin={true}
							noMobile={true}
						/>
					</div>
					{this.renderStep()}
				</div>
			);
		},

		render: function() {
			return this.renderSteps();
		},
	})
);
